// import React from "react";
// import Button from "../../components/Button/Button";
// import Message from "../../components/Message/Message";
// import PrimaryMenu from "../../components/PrimaryMenu/PrimaryMenu";
// import SizeDefaultTypeArrowRight from "../../icons/SizeDefaultTypeArrowRight/SizeDefaultTypeArrowRight";
// import ActionSectionSubsection from "./sections/ActionSectionSubsection/ActionSectionSubsection";
// import BannerSigupSubsection from "./sections/BannerSigupSubsection/BannerSigupSubsection";
// import CardsOptionsSubsection from "./sections/CardsOptionsSubsection/CardsOptionsSubsection";
// import CarouselCardsSubsection from "./sections/CarouselCardsSubsection/CarouselCardsSubsection";
// import FootlerSubsection from "./sections/FootlerSubsection/FootlerSubsection";
// import ReviewsSubsection from "./sections/ReviewsSubsection/ReviewsSubsection";
// import TabletExperienceSubsection from "./sections/TabletExperienceSubsection/TabletExperienceSubsection";

// import wave from "../../../static/img/wave.svg";
// import waver from "../../../static/img/waver-2.svg";

// import "./style.scss";

// const ElementHomePage = () => {
//   return (
//     <main className="element-home-page" data-model-id="84:731">
//       <div className="div-3">
//         {/* Footer area + glow */}
//         <section className="overlap-8" aria-label="Footer">
//           <div className="ellipse-2" aria-hidden="true" />
//           <FootlerSubsection />
//         </section>

//         {/* Hero */}
//         <header className="overlap-9" aria-label="Hero">
//           <img
//             className="wave"
//             alt="Decorative wave background"
//             src={wave}
//             loading="eager"
//             decoding="sync"
//             draggable="false"
//           />

//           <PrimaryMenu
//             className="primary-menu-instance"
//             divClassName="primary-menu-3"
//             divClassName1="primary-menu-4"
//             divClassNameOverride="primary-menu-4"
//             loginAndRegisterClassName="primary-menu-5"
//             menuClassName="primary-menu-2"
//           />

//           <div className="discover-collect-wrapper">
//             <h1 className="discover-collect">
//               Discover, Collect &amp; Trade Your Favorite Cards
//             </h1>
//           </div>

//           <div className="subtitle">
//             <p className="text-wrapper-56">
//               Explore exclusive sports cards, connect with collectors, and grow
//               your collection — all in one place.
//             </p>
//           </div>

//           <Message className="message-instance" />

//           <div className="actions-button">
//             <Button
//               className="button-5"
//               icon
//               override={
//                 <SizeDefaultTypeArrowRight className="size-default-type-arrow-right" />
//               }
//               size="default"
//               state="default"
//               text="Start for Free"
//               type="primary"
//             />
//             <Button
//               className="button-6"
//               icon={false}
//               size="default"
//               state="default"
//               text="Browse the Marketplace"
//               type="secondary"
//             />
//           </div>

//           <CarouselCardsSubsection />
//         </header>

//         {/* Feature sections stack */}
//         <section className="overlap-10" aria-label="Features">
//           <img
//             className="waver"
//             alt="Decorative wave separator"
//             src={waver}
//             loading="lazy"
//             decoding="async"
//             draggable="false"
//           />

//           <CardsOptionsSubsection />
//           <TabletExperienceSubsection />
//           <BannerSigupSubsection />
//         </section>

//         {/* CTA + Social proof */}
//         <ActionSectionSubsection />

// {/* <div style={{width: '100%'}}>
//         <h2 className="text-wrapper-57">What Collectors Are Saying</h2>
//         <p className="text-wrapper-58">
//           Real feedback from passionate collectors just like you.
//         </p>
// </div> */}
//         <ReviewsSubsection />
//       </div>
//     </main>
//   );
// };

// export default ElementHomePage;


import React from "react";
import Button from "../../components/Button/Button";
import Message from "../../components/Message/Message";
import PrimaryMenu from "../../components/PrimaryMenu/PrimaryMenu";
import SizeDefaultTypeArrowRight from "../../icons/SizeDefaultTypeArrowRight/SizeDefaultTypeArrowRight";
import { useLocation, useNavigate } from "react-router-dom";
import ActionSectionSubsection from "./sections/ActionSectionSubsection/ActionSectionSubsection";
import BannerSigupSubsection from "./sections/BannerSigupSubsection/BannerSigupSubsection";
import CardsOptionsSubsection from "./sections/CardsOptionsSubsection/CardsOptionsSubsection";
import CarouselCardsSubsection from "./sections/CarouselCardsSubsection/CarouselCardsSubsection";
import FootlerSubsection from "./sections/FootlerSubsection/FootlerSubsection";
import ReviewsSubsection from "./sections/ReviewsSubsection/ReviewsSubsection";
import TabletExperienceSubsection from "./sections/TabletExperienceSubsection/TabletExperienceSubsection";

import wave from "../../../static/img/wave.svg";
import waver from "../../../static/img/waver-2.svg";

import "./style.scss";
import translations from "../../../../utils/language/translations.json";
import { useTranslation } from "react-i18next";

/**
 * Home page with semantic sections and normal flow layout.
 * - Only decorative layers (wave/glow) are absolutely positioned.
 * - Content uses container + grid/flex; no magic numbers or top/left offsets.
 */
const ElementHomePage = () => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;
  const navigate = useNavigate();
  const t = (key) => translations.HomePage?.[key]?.[currentLang] ?? key;
  return (
    <main className="home" data-model-id="84:731">
      {/* ===== HERO ===== */}
<header
  className="hero"
  aria-label="Hero"
  style={{ "--hero-bg": `url(${wave})`,marginTop: '0',marginBottom: '1vh' }}
  
>

    {/* PrimaryMenu, title, subtitle, <Message />, buttons, carousel… */}
 

        <div className="container hero__inner">
          {/* Top navigation in normal flow */}
          {/* <div className="hero__menu">
            <PrimaryMenu
              className="primary-menu"
              divClassName="is-primary"
              divClassName1="is-light"
              divClassNameOverride="is-light"
              loginAndRegisterClassName="is-auth"
              menuClassName="is-wide"
            />
          </div> */}

          {/* Main hero content */}
          <div className="hero__content">
             <div className="hero-pill beta-pill">
  🟢{t("Beta Early Access")}
</div>
             <Message className="hero__message" t={t} />
            <h2 className="hero__title">
             {t('The Marketplace Built for Hockey & Pokémon Collectors')}
            </h2>

 <p className="hero__subtitle founder">
              {t('Built by a collector frustrated with spreadsheets and Facebook chaos.')}

            </p>
            <p className="hero__subtitle plus">
              {t('Track, trade and grow your Hockey & Pokémon card collection — all in one place.')}

            </p>

           

            <div className="hero__actions">
              <Button
                className="hero__cta"
                icon
                override={<SizeDefaultTypeArrowRight />}
                size="default"
                state="default"
                text={t('Start for Free')}
onClick={()=> navigate(i18n.language === 'fr' ? '/fr/login' : '/login')}
                type="primary"
              />
              <Button
                className="hero__cta"
                icon={false}
                size="default"
                state="default"
                text={t('Browse the Marketplace')}
                onClick={()=> navigate(i18n.language === 'fr' ? '/fr/marketplace' : '/marketplace')}
                type="secondary"
              />
            </div>
          </div>

          {/* Cards carousel sits naturally after actions */}
              <div className="hero__carousel">
           
            <CarouselCardsSubsection title={t('Featured Hockey & Pokémon Cards')}t={t} i18n={i18n}
 />
          </div>
        </div>

  <span className="hero__glow" aria-hidden="true" />
</header>


        {/* Optional glow layer (purely decorative) */}
      <section className="features" aria-label="Features"> 
        {/* Decorative divider */}
        <img className="features__bg" src={waver} alt="" aria-hidden="true" />
        <div className="container features__inner">
          <TabletExperienceSubsection t={t} />
          <CardsOptionsSubsection t={t}/>
          
         <BannerSigupSubsection t={t} i18n={i18n} navigate={navigate}/>
        </div>
      </section>
  {/* ===== CTA SECTION ===== */}
        <section className="cta" aria-label="Call to action">
        <div className="container">
          <ActionSectionSubsection t={t} />
        </div>
      </section>


      {/* ===== FEATURES STACK ===== */}
     

      {/* ===== REVIEWS ===== */}
      <section className="reviews" aria-label="What collectors are saying">
        <div className="container">
          <ReviewsSubsection t={t}/>
        </div>
      </section>
<span className="page-bottom-glow" aria-hidden="true" />

{/* Page-level bottom glow (bleeds behind reviews + footer) */}
      {/* 
      {/* ===== FOOTER ===== *
      
      <footer className="site-footer" aria-label="Footer">
      
        
        <div className="container">
          
          <FootlerSubsection />
        </div>
      </footer> */}
    </main>
  );
};

export default ElementHomePage;
